import { fg } from '@atlassian/jira-feature-gating';

const RemoveSearchurlFromCmdbFieldRelayProvider = {
	get(): boolean {
		return fg('flash-839-remove-searchurl-from-cmdb-field');
	},
};

export default RemoveSearchurlFromCmdbFieldRelayProvider;
